/* tslint:disable */
import {
  County
} from '../index';

declare var Object: any;
export interface CityInterface {
  "mtp"?: string;
  "name"?: string;
  "type"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  county?: County[];
}

export class City implements CityInterface {
  "mtp": string;
  "name": string;
  "type": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  county: County[];
  constructor(data?: CityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `City`.
   */
  public static getModelName() {
    return "City";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of City for dynamic purposes.
  **/
  public static factory(data: CityInterface): City{
    return new City(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'City',
      plural: 'Cities',
      path: 'Cities',
      idName: 'id',
      properties: {
        "mtp": {
          name: 'mtp',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        county: {
          name: 'county',
          type: 'County[]',
          model: 'County',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'cityId'
        },
      }
    }
  }
}
